<template>
    <div class="position-relative component">
        <div class="text-center pb-3 d-flex flex-column gap-2 align-items-center">
            <div v-if="allDone">
                <h1 class="d-flex align-items-center gap-3 justify-content-center">
                    <i class="fi fi-rr-party-horn"></i>
                    {{ trans('general.setup.congratulations') }}
                </h1>
                <p class="mt-4" style="max-width: 500px;">
                    {{ trans('general.setup.finished_text') }}
                </p>
            </div>
            <div v-else>
<!--                <h1>-->
<!--                    {{ trans('general.setup.almost_done') }}...-->
<!--                </h1>-->
                <p class="mt-4" style="max-width: 450px;">
                    {{ trans('general.setup.almost_done_text') }}
                </p>
            </div>
            <div class="ratio ratio-16x9">
                <iframe src="https://www.youtube.com/embed/LVX2GZoFNak?rel=0" allowfullscreen></iframe>
            </div>
        </div>

        <setup-footer ref="setupFooter" :step="step" v-on="$listeners" @nextStep="setupDone"/>
    </div>
</template>

<script>
import SetupFooter from "../molecules/SetupFooter.vue";

export default {
    name: "Finish",
    components: {SetupFooter},
    props: {
        step: {
            type: Number
        },
        allDone: {
            type: Boolean
        }
    },
    methods: {
        setupDone() {
            this.$emit('finishSetup');
        },
        checkAllDone() {
            if(this.allDone) {
                this.$refs.setupFooter.setButtonText(true);
            } else {
                this.$refs.setupFooter.setButtonText(trans('general.setup.finish_later'));
            }
        }
    },
    mounted() {
        this.checkAllDone();
    }
}
</script>
